import { Cookies } from "react-cookie";
const COOKIE_KEY_MARKET = "market";
const COOKIE_KEY_FLAG_MARKET = "flagMarket";
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

const getMarket = (): string => {
  const cookie = new Cookies();
  const value = cookie.get(COOKIE_KEY_MARKET);

  if (!value) {
    return "";
  }

  return String(value);
};

const getFlagMarket = (): string => {
  const cookie = new Cookies();
  const value = cookie.get(COOKIE_KEY_FLAG_MARKET);

  if (!value) {
    return "";
  }

  return String(value);
};

const setMarket = (value: string) => {
  const cookie = new Cookies();
  const options = {
    path: "/",
    maxAge: ONE_YEAR_IN_SECONDS,
  };

  cookie.set(COOKIE_KEY_MARKET, value, options);
};

const setFlagMarket = (value: string) => {
  const cookie = new Cookies();
  const options = {
    path: "/",
    maxAge: ONE_YEAR_IN_SECONDS,
  };

  cookie.set(COOKIE_KEY_FLAG_MARKET, value, options);
};

export const cookies = {
  getFlagMarket,
  getMarket,
  setFlagMarket,
  setMarket,
};
